import React, { Component } from "react";
import { Input, Form } from 'antd';
import './index.less';
export default class NumberContainer extends Component {
  render() {
    const {
      data,
      sceneCode
    } = this.props;
    const {
      getFieldDecorator
    } = this.props.form;
    const conInput = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || '';

          if (data.required && val === '') {
            callback('必填项，请输入相关信息');
            return;
          }

          let reg = new RegExp(/^[0-9]\d*$/, "g");

          if (val && !reg.test(value)) {
            callback('只能输入数字');
            return;
          }

          if (val && val.length > data.length) {
            callback(`输入长度不超过${data.length}`);
            return;
          }

          callback();
        }
      }],
      initialValue: data.value || ''
    })(<Input data-inspector-line="32" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\NumberContainer\\index.jsx" maxLength={data.length || null} placeholder={sceneCode && sceneCode == '1' ? data.fieldTip : '请输入'} disabled={data.frontUpdateFlag === 1} />);
    return <div data-inspector-line="35" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\NumberContainer\\index.jsx" className="detail-sel-number detail-sel-wrap">
        <Form.Item data-inspector-line="36" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\NumberContainer\\index.jsx">
          {conInput}
        </Form.Item>
      </div>;
  }

}